
export default {
    SET_SELECTED_CONIDS(state, selectedConids) {
        state.selectedConids = selectedConids || [];
    },
    SET_FOLIO_MODELS(state, folioModels) {
        state.folioModels = folioModels;
    },
    SET_SELECTED_MODEL(state, selectedModel) {
        state.selectedModel = selectedModel;
    },
    SET_PERFORMANCE_CHART_DATA(state, data) {
        state.performanceChartData = data;
    },
    SET_SAVED_MODEL_REQUEST_STATUS(state, status) {
        state.savedModelStatus = status;
    },
    SET_REBALANCE_FOLIO_MODEL(state, orderDetails) {
        state.rebalancedOrderDetails = orderDetails;
    },
    SET_TRANSMIT_ORDER_STATUS(state, status) {
        state.transmitOrdersStatus = status;
    },
    SET_MODEL_ORDERS_STATUS(state, status) {
        state.modelOrdersStatus = status;
    },
    SET_MODEL_TARGET_LIST(state, list) {
        state.modelTargetList = list;
    }
};
